import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

/**
 * Component used to create Icons.
 *  To use this FnIconComponent  import FnIconModule in Module.
 */
@Component({
  selector: 'fn-icon',
  templateUrl: './fn-icon.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnIconComponent implements AfterViewInit {

  /**
   * Input  member variable
   * used to pass the FontAwesome Icon Name .
   */
  @Input() icon: string;

  // tslint:disable-next-line: no-inferrable-types
  /**
   * Input member variable
   * it define from which lib icons to used 
   * by default icons used from FontAwesome(fa);
   */
  @Input() lib = 'fn';

  /**
   * Input member variable
   * used to pass the css properties like {color:#..;height:..px;...} as inline style.
   */
  @Input() style: string;

  /**
   * Input member variable
   * used to set the size of icon.
   */
  @Input() size: string;

  /**
   * Input member variable
   * used to animate icon like to spin or pluse icon
   */
  @Input() animation: string;

  /**
   * Input member variable
   * used to pass icon color;
   */
  @Input() color: string;

  /**
   * Input member variable
   * used to align icon left,right and center;
   */
  @Input() align: string;
 

  /**
    * View child of fn icon component
    */
  @ViewChild(TemplateRef, { static: true }) template: TemplateRef<any>;

  /**
   * Creates an instance of fn icon component.
   * @param ChangeDetectorRef object
   */
  constructor(private change: ChangeDetectorRef) { }

  /**
   * Implements ngAfterViewInit event handler.
   */
  ngAfterViewInit() { 
  }

 

  /**
   * Determines whether full code is
   * @returns  
   */
  isFullCode() {
    const space = this.icon.indexOf(' ');
    return space !== -1;
  }

  /**
   * this method get style from icon input 
   */
  getStyle() {
    let fistSplit: number;
    let secondSplit: number;

    if (this.lib === 'fn') {
      fistSplit = 0;
      secondSplit = this.icon.indexOf(' ');
    }

    if (this.lib === 'ion') {
      fistSplit = this.icon.indexOf('-') + 1;
      secondSplit = this.icon.indexOf('-', fistSplit) - fistSplit;
    }

    this.setStyle(fistSplit, secondSplit);
  }

  /**
   * Sets style for icon 
   * @param start 
   * @param length 
   */
  setStyle(start: number, length: number) {
    this.style = this.icon.substr(start, length);

    switch (this.lib) {
      case 'dx':
        this.setIcon(16);
        break;
      case 'fn':
        const fistSplit = this.icon.indexOf('-') + 1;
        this.setIcon(fistSplit);
        break;
      case 'other':
        this.setIcon((start + length) + 1);
        break;
    }
  }

  /**
   * Sets icon
   * @param start 
   */
  setIcon(start: number) {
    this.icon = this.icon.substr(start);
  }

}
